function omitProp(props, propToOmit) {
  const { [propToOmit]: _, ...filteredProps } = props;
  return filteredProps;
}
export {
  omitProp
};
